import { render, staticRenderFns } from "./GPDownloadEvent.vue?vue&type=template&id=410e1435&"
import script from "./GPDownloadEvent.vue?vue&type=script&lang=js&"
export * from "./GPDownloadEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports